import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid } from '@material-ui/core'
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import ConfirmMsgDialog from '../msg-dialogs/confirm-msg-dialog'

const initialState = {
    input: {},
    dialogOpen: false,
    isLoading: false,
}

class EditPreventionManualDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditPreventionManualDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        this.setState({
            input: {
                ...inputs,
                threshold_prevention_manual:
                    this.props.owner.gameRiskInfoList[
                        utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_MANUAL, inputs.pf_sub_pf_id)
                    ].ban_score,
                expired_date_prevention_manual:
                    this.props.owner.gameRiskInfoList[
                        utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_MANUAL, inputs.pf_sub_pf_id)
                    ].expired_at,
            },
            isLoading: false,
        })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t('title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('banScore')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.threshold_prevention_manual}
                                onChange={(event) => {
                                    let value = Math.max(event.target.value, 1)
                                    if (Number.isNaN(value)) value = 1
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            threshold_prevention_manual: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DateTimePicker
                                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                                    minDateMessage={this.t('DatePicker.minDateMessage')}
                                    value={
                                        utils.datetimeToUnix(this.state.input.expired_date_prevention_manual) > 0
                                            ? this.state.input.expired_date_prevention_manual
                                            : utils.currentDatetime()
                                    }
                                    onChange={(value) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                expired_date_prevention_manual: value,
                                            },
                                        })
                                    }
                                    label={this.t('expiredDatePreventionManual')}
                                    format="yyyy/MM/dd HH:mm"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    this.setState({ isLoading: true })
                                    this.confirmDialog.OpenDialog({
                                        type: 'warn',
                                        msg: this.t('confirmCancelMsg'),
                                        confirm: (_params) => {
                                            this.confirmDialog.SetConfirmBtnDisabled(true)

                                            utils.apiRequest(
                                                'patch',
                                                API.RISKMGT_GAME_RISK_INFO,
                                                {
                                                    id: this.props.owner.gameRiskInfoList[
                                                        utils.ComposeGameRiskInfoKey(
                                                            this.state.input.oid,
                                                            RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_MANUAL,
                                                            this.state.input.pf_sub_pf_id
                                                        )
                                                    ].id,
                                                    expired_at: 0,
                                                },
                                                (_data) => {
                                                    this.confirm()
                                                },
                                                (_err) => {
                                                    this.confirmDialog.SetConfirmBtnDisabled(false)
                                                    this.setState({ isLoading: false })
                                                }
                                            )
                                        },
                                    })
                                }}
                                color="primary"
                                disabled={this.state.isLoading}>
                                {this.t('cancelPreventionManual')}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })

                            utils.apiRequest(
                                'patch',
                                API.RISKMGT_GAME_RISK_INFO,
                                {
                                    id: this.props.owner.gameRiskInfoList[
                                        utils.ComposeGameRiskInfoKey(
                                            this.state.input.oid,
                                            RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_MANUAL,
                                            this.state.input.pf_sub_pf_id
                                        )
                                    ].id,
                                    ban_score: parseFloat(this.state.input.threshold_prevention_manual),
                                    expired_at: utils.datetimeToUnix(this.state.input.expired_date_prevention_manual),
                                },
                                (_data) => {
                                    this.confirm()
                                },
                                (_err) => {
                                    this.setState({ isLoading: false })
                                }
                            )
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
    }
}

EditPreventionManualDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    owner: PropTypes.object,
}

export default hoc(styles)(EditPreventionManualDialog)
